var React = require('react');

function FlagIntersex (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_667_16608)","key":0},[React.createElement("rect",{"y":"0.333496","width":"32","height":"21.3333","fill":"#FCDF5C","key":0}),React.createElement("rect",{"x":"10","y":"5.3335","width":"12","height":"12","rx":"6","stroke":"#78377E","strokeWidth":"2","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_667_16608"},React.createElement("rect",{"y":"0.333496","width":"32","height":"21.3333","rx":"2.13333","fill":"white"})))]);
}

FlagIntersex.defaultProps = {"width":"32","height":"22","viewBox":"0 0 32 22","fill":"none"};

module.exports = FlagIntersex;

FlagIntersex.default = FlagIntersex;
